import { render, staticRenderFns } from "./QuestionsTypeAdd.vue?vue&type=template&id=b23d1192&scoped=true&"
import script from "./QuestionsTypeAdd.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23d1192",
  null
  
)

export default component.exports